import styled from '@emotion/styled';
import type { UserProfile } from '@/lib/services/auth.service';
import { SubscriptionsDashboard } from './SubscriptionsDashboard';

const PageTitle = styled.h2`
  font-size: 30px;
  font-weight: 600;
  line-height: 1.27;
  color: #292929;
  margin: 0;
`;

interface AutoshipDashboardProps {
  readonly user: UserProfile;
}

export function AutoshipDashboard({ user }: AutoshipDashboardProps) {
  return (
    <SubscriptionsDashboard
      user={user}
      planType="autoship"
      activeCardLayout="grid"
      header={<PageTitle>Autoship</PageTitle>}
      emptyState={{
        title: 'No autoship subscriptions yet',
        description:
          'When you subscribe to an autoship plan, your subscriptions will appear here.',
      }}
      toasts={{
        canceled: 'Your autoship has been canceled.',
      }}
      cancelFeedbackBanner={{
        heading: 'Your subscription has been canceled.',
      }}
      retentionSuccessBanner={{
        productLabel: 'subscription',
      }}
    />
  );
}
